import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Arg, Entity, Field, Query } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { CampusEvent } from '../campus-learning-content/entities/CampusEvent.js';
import { CampusExercise } from '../campus-learning-content/entities/CampusExercise.js';
import { CampusLesson } from '../campus-learning-content/entities/CampusLesson.js';
import { CampusSection } from '../campus-learning-content/entities/CampusSection.js';

@Entity()
export class CampusScope extends MongoEntity {
  public static override _class = 'CampusScope';
  public static override _collectionName = 'campus-scopes';

  @validate(nonOptional())
  @Field(type => String)
  public name!: string;

  @Query(type => Int)
  public static countExercisesForScope(@Arg('scopeID', type => String) scopeID: string) {
    return async (gqlFields: void) => {
      const col = await getCollection(CampusExercise._class);
      const num = await col.countDocuments({ scopes: scopeID });
      return num;
    };
  }

  @Query(type => Int)
  public static countLessonsForScope(@Arg('scopeID', type => String) scopeID: string) {
    return async (gqlFields: void) => {
      const col = await getCollection(CampusLesson._class);
      const num = await col.countDocuments({ scopes: scopeID });
      return num;
    };
  }

  @Query(type => Int)
  public static countTopicsForScope(@Arg('scopeID', type => String) scopeID: string) {
    return async (gqlFields: void) => {
      const col = await getCollection(CampusSection._class);
      const num = await col.countDocuments({ scopes: scopeID });
      return num;
    };
  }

  @Query(type => Int)
  public static countEventsForScope(@Arg('scopeID', type => String) scopeID: string) {
    return async (gqlFields: void) => {
      const col = await getCollection(CampusEvent._class);
      const num = await col.countDocuments({ scopes: scopeID });
      return num;
    };
  }
}
